import store from '@/store'
import { Action, config, Module, Mutation, VuexModule } from "vuex-module-decorators";

config.rawError = true

const name = 'navigation';
if (module.hot) {
    if (store.hasModule(name)) {
        store.unregisterModule(name);
    }
}

@Module({dynamic: true, store: store, name: name, namespaced: true})
export default class Navigation extends VuexModule {

    redirectAfterAuthPath: any = '';
    requiredStart: string = '';
    requiredEnd: string = '';
    guestName: string = '';
    autocomplete: string = '';
    anonUserId: string = '';

    @Mutation
    setRedirectAfterAuthPath(payload: string) {
        this.redirectAfterAuthPath = payload;
    }

    @Mutation
    _setRequiredEnd(payload: string) {
        this.requiredEnd = payload;
    }

    @Mutation
    _setGuestName(payload: string) {
        this.guestName = payload;
    }

    @Mutation
    _setAutocomplete(payload: string) {
        this.autocomplete = payload;
    }

    @Mutation
    _setAnonUserId(payload: string) {
        this.anonUserId = payload;
    }

    @Action
    async changeRedirectAfterAuthPath(payload: string) {
        this.setRedirectAfterAuthPath(payload);
    }

    @Action
    async setRequiredEnd(payload: string) {
        this._setRequiredEnd(payload);
    }

    @Action
    async setGuestName(payload: string) {
        this._setGuestName(payload);
    }

    @Action
    async setAutocomplete(payload: string) {
        this._setAutocomplete(payload);
    }

    @Action
    async setAnonUserId(payload: string) {
        this._setAnonUserId(payload);
    }

}
